import { observer } from 'mobx-react-lite';
import { createContext, FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import 'reflect-metadata';

import { MFErrorText } from '~/components/reuseable/MFErrorText';

import { useMFBaseContext } from '../hooks/useMFBaseContext';
import { MFBaseContextPropsType } from './MFBaseProvider';

export type MFMessagesContextPropsType = MFBaseContextPropsType & {
  documentTypeId: number;
  documentId: number;
  isDisabled?: boolean;
};

export type MFMessagesProviderPropsType = MFMessagesContextPropsType & {
  children: ReactNode;
};

export const MFMessagesContext = createContext<MFMessagesContextPropsType | undefined>(undefined);

// TS не передается в родительские проекты,
// поэтому определяем проверяем обязательные пропы на undefined
const requiredProps: Partial<keyof MFMessagesContextPropsType>[] = ['documentId', 'documentTypeId'];

export const MFMessagesProvider: FC<MFMessagesProviderPropsType> = observer((props) => {
  const mfBaseContext = useMFBaseContext();
  const { t } = useTranslation('common');

  if (requiredProps.some((prop) => props[prop as keyof MFMessagesContextPropsType] === undefined)) {
    console.log(t('error.requiredPropsNotFound'));

    return <MFErrorText />;
  }

  const contextValue = {
    ...mfBaseContext, // наследуем базовый контекст
    ...props,
  };

  return <MFMessagesContext.Provider value={contextValue}>{props.children}</MFMessagesContext.Provider>;
});
